import { UserRoles } from '@diditusa/shared/types/commonTypes';
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import Home from './home';
import ManagerHome from './home.manager';

export default function HomeSwitch() {
  const { userRole } = useAuth();
  if (userRole === UserRoles.MANAGER) {
    return <ManagerHome />;
  }

  return <Home />;
}
